class FinancialGoalApi {
    getListByCurrentBusiness() {
        return api.call('get', apiUrl + 'financialGoals/currentBusiness/')
            .then(({ data }) => data);
    }
    get(id) {
        return api.call('get', apiUrl + 'financialGoals/' + id)
            .then(({ data }) => data);
    }
    create(data) {
        return api.call('post', apiUrl + 'financialGoals', data)
            .then(({ data }) => data);
    }
    update(data) {
        return api.call('put', apiUrl + 'financialGoals/' + data.id, data)
            .then(({ data }) => data);
    }
    delete(id) {
        return api.call('delete', apiUrl + 'financialGoals/' + id)
            .then(({ data }) => data);
    }
}

export default FinancialGoalApi;
